__turbopack_context__.v({
  "circle": "fLgm4W_circle",
  "circles": "fLgm4W_circles",
  "image": "fLgm4W_image",
  "line": "fLgm4W_line",
  "line-short": "fLgm4W_line-short",
  "product-tile-skeleton-shimmer": "fLgm4W_product-tile-skeleton-shimmer",
  "skeleton": "fLgm4W_skeleton",
});
